import * as React from "react";
import { match } from "react-router-dom";
import { connect } from "react-redux";
import { GlobalState } from "../../store/rootReducer";
import { Dispatch } from "redux";

import { Wrap } from "./styles";
import { confirmRequest, IConfirmRequest } from "../../store/Confirm/actions";

import { withTranslation, WithTranslation } from "react-i18next";
import Confirm from "../../components/Confirm";
import ZLoader from "../../components/ZLoader";

type Props = {
  match?: match<any>;
  email?: string | null;
  loaded: boolean | null;
  loading: boolean;
  logged: boolean;
  confirmRequest: (hash: string, confirmCode: string) => IConfirmRequest;
} & WithTranslation;

type State = {};

class ConfirmByHash extends React.Component<Props, State> {
  public readonly state: State = {};

  componentDidMount() {
    const { confirmRequest, loaded } = this.props;
    const { hash, confirmCode } = this.props.match?.params;

    if (hash && confirmCode && !loaded) {
      confirmRequest(hash, confirmCode);
    }
  }

  render() {
    const { email, logged, loading } = this.props;

    if (loading) return <ZLoader />;

    return (
      <Wrap>
        <Confirm email={email} logged={logged} />
      </Wrap>
    );
  }
}

function mapStateToProps(state: GlobalState) {
  const email = state.confirm.data && state.confirm.data.email;
  const { loaded, loading } = state.confirm;
  return {
    logged: !!state.myztokenuser.data?.userId,
    email,
    loaded,
    loading,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    confirmRequest: (hash: string, confirmCode: string) =>
      dispatch(confirmRequest(hash, confirmCode)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(ConfirmByHash));
